import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getMockDailyTotals, getMockFeedItems, USE_FEED_MOCKS } from "./winnersFeed.mocks";
import type { WinnersFeedDailyTotalsDto, WinnersFeedItemDto } from "./winnersFeed.types";

export type { WinnersFeedDailyTotalsDto, WinnersFeedItemDto } from "./winnersFeed.types";

export const winnersFeedApi = createApi({
  reducerPath: "winnersFeedApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.NEXT_PUBLIC_HOST }),
  tagTypes: ["WinnersFeed", "WinnersFeedDailyTotals"],
  endpoints: build => ({
    getFeedItems: build.query<WinnersFeedItemDto[], void>({
      queryFn: async (_arg, _api, _extraOptions, baseQuery) => {
        if (USE_FEED_MOCKS) return { data: getMockFeedItems() };
        const result = await baseQuery({ url: "/umbraco/BotB/WinnersFeed/Feed", credentials: "include" });
        if (result.error) return { error: result.error };
        return { data: result.data as WinnersFeedItemDto[] };
      },
      providesTags: ["WinnersFeed"],
    }),
    getDailyTotals: build.query<WinnersFeedDailyTotalsDto, void>({
      queryFn: async (_arg, _api, _extraOptions, baseQuery) => {
        if (USE_FEED_MOCKS) return { data: getMockDailyTotals() };
        const result = await baseQuery({ url: "/umbraco/BotB/WinnersFeed/DailyTotals", credentials: "include" });
        if (result.error) return { error: result.error };
        return { data: result.data as WinnersFeedDailyTotalsDto };
      },
      providesTags: ["WinnersFeedDailyTotals"],
    }),
  }),
});

export const { useGetFeedItemsQuery, useGetDailyTotalsQuery } = winnersFeedApi;
